import { render } from "./HeroiconsSolidChatAlt.vue?vue&type=template&id=304000ee"
const script = {}

import exportComponent from "/var/www/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidChatAlt.vue"]])

export default __exports__